/*
* @Author: 王春岩 <Bolt>
* @Date:   2017-05-16 13:06:23
* @Last Modified by:   Bolt
* @Last Modified time: 2017-05-16 15:05:59
*/

'use strict';

import stores, { VueParent } from 'babel-loader!./stores.babel.js';

import { Layer } from 'babel-loader!./Layer.babel.js';

export function install(Vue) {
    if (install.installed) {
        return false;
    }

    install.installed = true;

    VueParent.Vue = Vue;

    Vue.component('layer-view', {
        props: {
            name: {
                default: 'default'
            }
        },
        render(h) {
            if (!stores[this.name]) {
                stores[this.name] = new Layer(this.name);
            }
            return h('div',
                stores[this.name].storeData.list.map(v =>
                    h(v.component, Object.assign({}, v.attributes, {
                        on: Object.assign({}, ((v.attributes && v.attributes.on) || {}), {
                            close: () => {
                                stores[this.name].storeData.forbidScroll = false;
                            }
                        })
                    }), v.children)
                )
            );
        },
        beforeDestroy() {
            stores[this.name] = undefined;
            delete stores[this.name];
        }
    });

    stores['default'] = new Layer();
    Vue.$layer = stores['default'].init();
    Vue.prototype.$layer = Vue.$layer;

    Vue.$layer.use = function (name) {
        if (!stores[name]) {
            stores[name] = new Layer(name);
        }
        return stores[name].init();
    };
    Vue.prototype.$layer.use = Vue.$layer.use;
}



// WEBPACK FOOTER //
// ./~/@souche-f2e/weidian-util-vue-layer/src/install.babel.js